<!-- begin:: Footer -->
<div class="kt-footer kt-grid__item" id="kt_footer">
	<div class="kt-container" [ngClass]="{ 'kt-container--fluid': fluid }">
		<div class="kt-footer__wrapper">
			<div class="kt-footer__copyright">
				Copyright &copy; {{ today | date: 'yyyy' }} <a href="#" target="_blank">Acquirely PTY LTD</a>. All rights reserved.
			</div>
			<div class="kt-footer__menu">
				<span>Mailing address: Acquirely PTY LTD, 200 Queen Street, Melbourne VIC 3000</span>
			</div>
		</div>
	</div>
</div>
<!-- end:: Footer -->
